module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.78b3fc32.jpg";